











































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import { timeoutDefault } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import { SolicitacaoAcoesBackofficeEnum } from '@/types/_'
import { Autorizacao } from '@/types/core'

@Component
export default class ComponentModalRetornarCotacaoBtn extends Vue {
  @Prop({ required: true, default: '' }) modalParent: string
  @Prop({ required: false, default: true }) outline: boolean
  @Prop({ required: false, default: false }) dark: boolean
  context: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()
  $refs!: {
    form: any,
  }

  formRules: any = {
    valid: true,
    comentarios: [v => !!v || 'O campo comentários é obrigatório.'],
  }

  modal: boolean = false
  loadSave: boolean = false
  loadCloseToolbar: boolean = false
  loadCloseCancelar: boolean = false

  get loadingCloseCancelar() {
    return this.loadCloseCancelar
  }

  set loadingCloseCancelar(value: boolean) {
    this.loadCloseCancelar = value
  }

  get loadingCloseToolbar() {
    return this.loadCloseToolbar
  }

  set loadingCloseToolbar(value: boolean) {
    this.loadCloseToolbar = value
  }

  get loadingSave() {
    return this.loadSave
  }

  set loadingSave(value: boolean) {
    this.loadSave = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get comentarios() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.comentarios
      : ''
  }

  set comentarios(value: string) {
    this.getBackofficeGlobalStore.setComentarios(value)
  }

  async closeToolbar() {
    this.loadingCloseToolbar = true
    await timeoutDefault()
    this.modal = false
    this.getBackofficeGlobalStore.clearComentarios()
    this.loadingCloseToolbar = false
  }

  async closeCancelar() {
    this.loadingCloseCancelar = true
    await timeoutDefault()
    this.modal = false
    this.getBackofficeGlobalStore.clearComentarios()
    this.loadingCloseCancelar = false
  }

  async retornarOperadora() {
    this.loadingSave = true

    if (this.$refs.form.validate()) {
      const { comentarios } = this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo!
      const { id } = this.getBackofficeGlobalStore.solicitacao

      const params = {
        acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoFazRetornoParaCotacao,
        body: {
          solicitacaoId: id,
          comentarios,
        },
      }

      const response = await this.context.enviarGuias(params)
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Solicitacao enviada para aguardando cotação com sucesso!', icon: 'done', color: '#2E7D32' })
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema na solicitação..', icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingSave = false
  }

  async closeModal() {
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.context.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    solicitacaoId = ''
    this.getBackofficeGlobalStore.closeModalAutorizarProcesso()
    this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    this.modal = false
    this.getBackofficeGlobalStore.setModal({ name: this.modalParent, value: false })
  }

  @Watch('modal')
  onModalChange(value: boolean) {
    if (!value) this.$refs.form.resetValidation()
  }
}
